export const UPDATE_ANSWERS = 'UPDATE_ANSWERS';